import axios from 'axios';

const setupAxiosInterceptors = (showError) => {
    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            // Handle 401 Unauthorized (Session Expired handled by SuperTokens usually, but good to have)
            if (error.response && error.response.status === 401) {
                // Let SuperTokens handle redirect or refresh?
                // Usually SuperTokens intercepts this automatically if we use their axios interceptor?
                // We should check if we need to add SuperTokens interceptor.
                // SuperTokens handles this via `Session.init`.
            }

            // Handle 403 Usage Limit / Subscription
            if (error.response && error.response.status === 403) {
                const code = error.response.data?.code;
                if (code === 'USAGE_LIMIT_EXCEEDED') {
                    const details = error.response.data.details;
                    let message = "Usage limit exceeded.";
                    if (details && details.nextResetDate) {
                        const date = new Date(details.nextResetDate).toLocaleDateString();
                        message += ` Limits will reset on ${date}.`;
                    }
                    showError(message);
                    return Promise.reject(error); // Still reject so caller knows
                }
                if (code === 'SUBSCRIPTION_REQUIRED') {
                    // This might be handled by the Layout modal, but showing an error is also fine.
                    // Or supress it if we want the modal to be the only feedback.
                    // The modal listens to `user.subscriptionStatus`.
                    // If the user state is updated (e.g. via profile fetch), the modal shows.
                    // But if an action fails, we should alert.
                    showError(`Subscription Required: ${error.response.data.error}`);
                    return Promise.reject(error);
                }
            }

            // Reject other errors so specific handlers can catch them
            return Promise.reject(error);
        }
    );
};

export default setupAxiosInterceptors;
